const formatTimestamp = timestamp => {
  return Intl.DateTimeFormat('pt-br', { month: 'long', day: 'numeric', year: 'numeric' }).format(
    new Date(parseInt(timestamp))
  )
}

const isGreaterThan = (days, phoneVerifiedAt) => {
  const date = new Date(phoneVerifiedAt)
  // One day in milliseconds
  const oneDay = 1000 * 60 * 60 * 24
  // Calculating the time difference between two dates
  const diffInTime = Date.now() - date.getTime()
  // Calculating the no. of days between two dates
  const diffInDays = Math.round(diffInTime / oneDay)

  return diffInDays > days
}

const formatedTime = secondsFull => {
  const hours = Math.floor(secondsFull / 3600)
  const minutes = Math.floor((secondsFull % 3600) / 60)
  const seconds = Math.floor((secondsFull % 3600) % 60)

  const showHours = hours > 0 ? `${hours}h` : ''
  const showMinutes = minutes > 0 ? `${minutes}min` : ''
  const showSeconds = hours === 0 && seconds > 0 ? `${seconds}s` : ''

  return `${showHours}${!!showHours && !!showMinutes ? ' e' : ''} ${showMinutes}${
    showMinutes && showSeconds ? ' e ' : ''
  }${showSeconds}`
}

export { formatTimestamp, isGreaterThan, formatedTime }
